import { AXIS_AESTHETIC } from './products';

export const documentsType = {
  NB: {
    NB_DOC_ACCEPT_LETTER: 'Policy Letter',
    NB_DOC_ACCEPT_WORDING: 'Policy Wording',
    NB_DOC_ACCEPT_WORDING1: 'Policy Wording',
    NB_DOC_ACCEPT_WORDING2: 'Policy Wording',
    NB_DOC_ACCEPT_WORDING3: 'Policy Wording',
    NB_DOC_ACCEPT_WORDING4: 'Policy Wording',
    NB_DOC_ACCEPT_SUMMARY: 'Policy Summary',
    NB_DOC_ACCEPT_SCHEDULE: 'Policy Schedule',
    NB_DOC_ACCEPT_SOF: 'Policy Statement Of Facts',
    NB_DOC_ACCEPT_ADDONS: 'Add on Covers',
    NB_DOC_LETTER: 'Policy Letter',
    NB_DOC_ACCEPT_POC: 'Proof Of Cover Letter',
    NB_DOC_ACCEPT_ELCERT: 'Employers Liability Certificate',
    NB_DOC_ACCEPT_IPID: 'Insurance Product Information Document',
    NB_DOC_ACCEPT_IPID1: 'Insurance Product Information Document',
    NB_DOC_ACCEPT_IPID2: 'Insurance Product Information Document',
    NB_DOC_ACCEPT_IPID3: 'Insurance Product Information Document',
    NB_DOC_ACCEPT_IPID4: 'Insurance Product Information Document',
    NB_DOC_ACCEPT_IPID5: 'Insurance Product Information Document',
    NB_DOC_ACCEPT_IPID6: 'Insurance Product Information Document',
    NB_DOC_ACCEPT_IPID7: 'Insurance Product Information Document',
    NB_DOC_ACCEPT_IPID8: 'Insurance Product Information Document',
    NB_DOC_ACCEPT_LEGAL_WORDING: 'General Liability Wording',
    NB_DOC_ACCEPT_SUMMARY_OF_CHANGE: 'Summary Of Change'
  },
  MTA_ACCEPT: {
    MTA_DOC_ACCEPT_LETTER: 'MTA Acceptance Letter',
    MTA_DOC_ACCEPT_WORDING: 'MTA Policy Wording',
    MTA_DOC_ACCEPT_WORDING1: 'MTA Policy Wording',
    MTA_DOC_ACCEPT_WORDING2: 'MTA Policy Wording',
    MTA_DOC_ACCEPT_WORDING3: 'MTA Policy Wording',
    MTA_DOC_ACCEPT_WORDING4: 'MTA Policy Wording',
    MTA_DOC_ACCEPT_SUMMARY: 'MTA Policy Summary',
    MTA_DOC_ACCEPT_SCHEDULE: 'MTA Policy Schedule',
    MTA_DOC_ACCEPT_ADDONS: 'MTA Add on',
    MTA_DOC_ACCEPT_SOF: 'MTA Policy SOF',
    MTA_DOC_ACCEPT_ELCERT: 'MTA Employers Liability Certificate',
    MTA_DOC_ACCEPT_LEGAL_WORDING: 'AXIS Combined GL Wording MTA',
    MTA_DOC_ACCEPT_POC: 'Proof Of Cover Letter',
    MTA_DOC_ACCEPT_IPID: 'MTA Insurance Product Information Document',
    MTA_DOC_ACCEPT_IPID1: 'MTA Insurance Product Information Document',
    MTA_DOC_ACCEPT_IPID2: 'MTA Insurance Product Information Document',
    MTA_DOC_ACCEPT_IPID3: 'MTA Insurance Product Information Document',
    MTA_DOC_ACCEPT_IPID4: 'MTA Insurance Product Information Document',
    MTA_DOC_ACCEPT_IPID5: 'MTA Insurance Product Information Document',
    MTA_DOC_ACCEPT_IPID6: 'MTA Insurance Product Information Document',
    MTA_DOC_ACCEPT_IPID7: 'MTA Insurance Product Information Document',
    MTA_DOC_ACCEPT_IPID8: 'MTA Insurance Product Information Document'
  },
  QUOTE: {
    QUOTE_DOC_ACCEPT_WORDING: 'Quote Wording',
    QUOTE_DOC_INVITE_SUMMARY: 'Quote Summary',
    QUOTE_DOC_ACCEPT_SCHEDULE: 'Quote Schedule',
    QUOTE_DOC_SOF: 'Quote Statement Of Facts',
    QUOTE_DOC_ADDONS: 'Add on Covers',
    QUOTE_DOC_LETTER: 'Quote Letter',
    QUOTE_DOC_ACCEPT_IPID: 'Policy IPID',
    QUOTE_DOC_ACCEPT_ELCERT: 'Quote Employers Liability Certificate',
    QUOTE_DOC_ACCEPT_LEGAL_WORDING: 'Quote General Liability Wording',
    QUOTE_DOC_SUMMARY_OF_CHANGE: 'Summary Of Change',
    QUOTE_DOC_ACCEPT_WORDING1: 'Quote Wording',
    QUOTE_DOC_ACCEPT_WORDING2: 'Quote Wording',
    QUOTE_DOC_ACCEPT_WORDING3: 'Quote Wording',
    QUOTE_DOC_ACCEPT_WORDING4: 'Quote Wording',
    QUOTE_DOC_ACCEPT_IPID1: 'Policy IPID',
    QUOTE_DOC_ACCEPT_IPID2: 'Policy IPID',
    QUOTE_DOC_ACCEPT_IPID3: 'Policy IPID',
    QUOTE_DOC_ACCEPT_IPID4: 'Policy IPID',
    QUOTE_DOC_ACCEPT_IPID5: 'Policy IPID',
    QUOTE_DOC_ACCEPT_IPID6: 'Policy IPID',
    QUOTE_DOC_ACCEPT_IPID7: 'Policy IPID',
    QUOTE_DOC_ACCEPT_IPID8: 'Policy IPID'
  },
  CANCELLATION: {
    CANX_DOC_ACCEPT_SCHEDULE: 'Cancellation Policy Schedule',
    CANX_DOC_ACCEPT_LETTER: 'Cancellation Policy Letter'
  },
  MANUAL_RENEWAL: {
    MR_DOC_INVITE_WORDING: 'Renewal Invite Wording',
    MR_DOC_INVITE_WORDING1: 'Renewal Invite Wording',
    MR_DOC_INVITE_WORDING2: 'Renewal Invite Wording',
    MR_DOC_INVITE_WORDING3: 'Renewal Invite Wording',
    MR_DOC_INVITE_WORDING4: 'Renewal Invite Wording',
    MR_DOC_INVITE_SUMMARY: 'Renewal Invite Summary',
    MR_DOC_INVITE_SCHEDULE: 'Renewal Invite Schedule',
    MR_DOC_INVITE_SOF: 'Renewal Invite Statement Of Facts',
    MR_DOC_INVITE_LETTER: 'Renewal Invite  Letter',
    MR_DOC_INVITE_ADDONS: 'Renewal Invite Add on Covers',
    MR_DOC_INVITE_IPID: 'Insurance Product Information Document',
    MR_DOC_INVITE_IPID1: 'Insurance Product Information Document',
    MR_DOC_INVITE_IPID2: 'Insurance Product Information Document',
    MR_DOC_INVITE_IPID3: 'Insurance Product Information Document',
    MR_DOC_INVITE_IPID4: 'Insurance Product Information Document',
    MR_DOC_INVITE_IPID5: 'Insurance Product Information Document',
    MR_DOC_INVITE_IPID6: 'Insurance Product Information Document',
    MR_DOC_INVITE_IPID7: 'Insurance Product Information Document',
    MR_DOC_INVITE_IPID8: 'Insurance Product Information Document',
    MR_DOC_INVITE_POC: 'Proof Of Cover Letter',
    MR_DOC_INVITE_ELCERT: 'Renewal Invite Employers Liability Certificate',
    MR_DOC_INVITE: 'Renewal Invite'
  },
  AUTO_RENEWAL: {
    AR_DOC_INVITE_WORDING: 'Renewal Invite Wording',
    AR_DOC_INVITE_WORDING1: 'Renewal Invite Wording',
    AR_DOC_INVITE_WORDING2: 'Renewal Invite Wording',
    AR_DOC_INVITE_WORDING3: 'Renewal Invite Wording',
    AR_DOC_INVITE_WORDING4: 'Renewal Invite Wording',
    AR_DOC_INVITE_SUMMARY: 'Renewal Invite Summary',
    AR_DOC_INVITE_SCHEDULE: 'Renewal Invite Schedule',
    AR_DOC_INVITE_SOF: 'Renewal Invite Statement Of Facts',
    AR_DOC_INVITE_LETTER: 'Renewal Invite Letter',
    AR_DOC_INVITE_ADDONS: 'Renewal Invite Add on Covers',
    AR_DOC_INVITE_IPID: 'Insurance Product Information Document',
    AR_DOC_INVITE_IPID1: 'Insurance Product Information Document',
    AR_DOC_INVITE_IPID2: 'Insurance Product Information Document',
    AR_DOC_INVITE_IPID3: 'Insurance Product Information Document',
    AR_DOC_INVITE_IPID4: 'Insurance Product Information Document',
    AR_DOC_INVITE_IPID5: 'Insurance Product Information Document',
    AR_DOC_INVITE_IPID6: 'Insurance Product Information Document',
    AR_DOC_INVITE_IPID7: 'Insurance Product Information Document',
    AR_DOC_INVITE_IPID8: 'Insurance Product Information Document',
    AR_DOC_INVITE_POC: 'Proof Of Cover Letter',
    AR_DOC_INVITE_ELCERT: 'Renewal Invite Employers Liability Certificate',
    AR_DOC_INVITE: 'Renewal Invite'
  },
  RENEWAL_ACCEPT: {
    RA_DOC_ACCEPT_WORDING: 'Renewal Acceptance Wording',
    RA_DOC_ACCEPT_SUMMARY: 'Renewal Acceptance Summary',
    RA_DOC_ACCEPT_SCHEDULE: 'Renewal Acceptance Schedule',
    RA_DOC_ACCEPT_SOF: 'Renewal Acceptance Statement Of Facts',
    RA_DOC_ACCEPT_LETTER: 'Renewal Acceptance Letter',
    RA_DOC_ACCEPT_ADDONS: 'Renewal Acceptance Add on Covers',
    RA_DOC_ACCEPT: 'Renewal Acceptance',
    RA_DOC_ACCEPT_POC: 'Proof Of Cover Letter',
    RA_DOC_ACCEPT_IPID: 'Renewal Policy IPID',
    RA_DOC_ACCEPT_IPID1: 'Renewal Policy IPID',
    RA_DOC_ACCEPT_IPID2: 'Renewal Policy IPID',
    RA_DOC_ACCEPT_IPID3: 'Renewal Policy IPID',
    RA_DOC_ACCEPT_IPID4: 'Renewal Policy IPID',
    RA_DOC_ACCEPT_IPID5: 'Renewal Policy IPID',
    RA_DOC_ACCEPT_IPID6: 'Renewal Policy IPID',
    RA_DOC_ACCEPT_IPID7: 'Renewal Policy IPID',
    RA_DOC_ACCEPT_IPID8: 'Renewal Policy IPID',
    RA_DOC_ACCEPT_WORDING1: 'Renewal Acceptance Wording',
    RA_DOC_ACCEPT_WORDING2: 'Renewal Acceptance Wording',
    RA_DOC_ACCEPT_WORDING3: 'Renewal Acceptance Wording',
    RA_DOC_ACCEPT_WORDING4: 'Renewal Acceptance Wording',
    RA_DOC_ACCEPT_ELCERT: 'Renewal Employers Liability Certificate'
  }
};

export const getDocumentName = (documentType, policyType, product) => {
  let documentName = documentsType[documentType.type.code][documentType.subType.code];
  if (!documentName) {
    return;
  }
  if (policyType === 'POLICY') {
    documentName = documentName.replace('Quote', 'Policy');
  }
  if (policyType === 'QUOTE') {
    documentName = documentName.replace('Policy', 'Quote');
  }
  if (product === AXIS_AESTHETIC && policyType === 'QUOTE' && documentName === 'Quote Statement Of Facts') {
    documentName = 'Quote Statement Of Facts & Treatment List';
  }
  if (product === AXIS_AESTHETIC && policyType === 'POLICY' && documentName === 'Policy Statement Of Facts') {
    documentName = 'Policy Statement Of Facts & Treatment List';
  }
  if (product === AXIS_AESTHETIC && documentType.type.code === 'MTA_ACCEPT' && documentType.subType.code === 'MTA_DOC_ACCEPT_SOF') {
    documentName = 'MTA Policy Statement Of Facts & Treatment List';
  }
  // eslint-disable-next-line consistent-return
  return documentName;
};
